import React, { useRef, useState, useEffect, useMemo } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default function CmtModal_CmtListReports(props) {
  const { modalState, toggleModal } = props;

  const closeBtn = (
    <button className="close" onClick={toggleModal}>
      <FontAwesomeIcon icon="times" className="fa-fw text-white" />
    </button>
  );

  return (
    <Modal isOpen={modalState.showModal} toggle={toggleModal} fade={false} size={"md"}>
      <ModalHeader toggle={toggleModal} className="bg-info text-white" close={closeBtn}>
        <FontAwesomeIcon icon="plus" className="fa-fw mr-2" />
        Reports
      </ModalHeader>
      <ModalBody>
        <div>Contents...</div>
      </ModalBody>
      <ModalFooter></ModalFooter>
    </Modal>
  );
}
